<style lang="less" scoped>
  @import './index.less';
</style>
<template>
  <div style="width:1100px;margin:0 auto;overflow-x:auto;">

    <!--表格头部开始-->
    <div class="table-head">
      <div class="table-th first">商品名称</div>
      <div class="table-th">单价（元）</div>
      <div class="table-th">数量</div>
      <div class="table-th">金额（元）</div>
      <div class="table-th">操作</div>
    </div>
    <!--表格头部结束-->

    <!--表格内容开始-->
    <div class="table-content">
      <el-table :data="tableData" style="width: 100%;" :show-header="false" empty-text="空空的购物车">
        <el-table-column label="商品名称">
          <template slot-scope="scope">
            <div class="product-name product-image">
              <img class="watermark" v-if="isSellOut(scope.row.activityProductId)" :src="sellOutImagePath">
              <img :src="scope.row.image" alt="">
            </div>
            <div class="product-name product-string">
              {{ scope.row.productName }}
            </div>
          </template>
        </el-table-column>

        <el-table-column label="单价（元）" width="170">
          <template slot-scope="scope">
            <span class="price">{{ scope.row.salePrice | price }}</span>
          </template>
        </el-table-column>

        <el-table-column label="数量" width="190">
          <template slot-scope="scope">
            <el-input-number @change="handleEdit(scope.row.id, scope.row.number)" :min="1" :size="'mini'" v-model="scope.row.number"></el-input-number>
          </template>
        </el-table-column>

        <el-table-column label="金额（元）" width="180">
          <template slot-scope="scope">
            <span class="red price">{{ (scope.row.number * scope.row.salePrice) | price }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <span @click="handleDelete(scope.row.activityProductId)" class="action-del">删除</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--表格内容结束-->

    <!--表格底部开始-->
    <div class="table-footer">
      <!--<router-link :to="{ name: 'order-confirm'}" v-if="tableData.length > 0">-->
        <!--<p class="right">下单</p>-->
      <!--</router-link>-->
      <p class="right" @click="placeOrder">下单</p>
      <p class="center" onclick="window.history.go(-1)">返回上一页</p>
      <p class="left">
        <span class="price fr">{{totalPrice | price}}</span>
        <span class="name fr">订单金额总计：</span>
      </p>
    </div>
    <!--表格底部结束-->
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import { isSellOut } from "@/helpers";
  const sellOutImagePath = require('../../assets/watermark/sell-out.png');

  export default {
    name: 'index',
    data() {
      return {
        num : 1,
        carts : [],
        sellOutImagePath,
        productSpecs : {},
      };
    },
    methods: {
      handleEdit(id, num) {
        this.$store.dispatch('cart/update', {id, num});
      },
      handleDelete(id) {
        this.$store.dispatch('cart/del', id);
      },
      isSellOut(activityProductId) {
        if(this.productSpecs[activityProductId] == null) {
          return false;
        }
        return isSellOut(this.productSpecs[activityProductId]);
      },
      async placeOrder() {
        const products = this.tableData;
        await this.$store.dispatch('activityLimit/limit', products).then((result)=>{
          if(result.result) {
            this.$router.push({name:'order-confirm'});
          }
        });
      },
      async _formatCart(carts) {
        let ids = [];
        carts.forEach((item)=>{
          ids.push(item.activityProductId);
        })
        let query = {id : "[" + ids + "]"}
        const result = await this.$store.dispatch('activityProducts/collection', {query});
        const productSpecs = result.collection;
        let specInfos = {};
        productSpecs.forEach((specInfo)=>{
          specInfos[specInfo.id] = specInfo;
        });
        this.productSpecs = specInfos;
      },
    },
    beforeMount() {
      this._formatCart(this.tableData);
    },
    mounted() {
    },
    computed : {
      ...mapState('cart', {
        tableData: state => state.cart
      }),
      ...mapGetters('cart', {
        cartNum : 'cartNum',
        totalPrice : 'totalPrice',
      }),
    },
  };
</script>


